// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bd-3";
export var contentContainer = "_bd-0";
export var editorContainer = "_bd-1";
export var quillInputForm = "_bd-2";
export var zoneDivider = "_bd-4";